import HelpIcon from '@mui/icons-material/Help';

function QuestionIcon({ onClickHandler, disabled = false }) {
    const handleClick = (event) => {
        if (disabled) return;
        event.preventDefault();
        event.stopPropagation();
        onClickHandler?.(event);
    };

    return (
        <HelpIcon
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-label="Open recipe selection"
            aria-disabled={disabled}
            onClick={handleClick}
            onKeyDown={(event) => {
                if (disabled) return;
                if (event.key === 'Enter' || event.key === ' ') {
                    handleClick(event);
                }
            }}
            sx={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                color: 'white',
                fontSize: '24px',
                backgroundColor: disabled ? 'grey.500' : 'primary.dark',
                opacity: disabled ? 0.55 : 1,
                margin: '8px 3px 3px 3px',
                padding: '2px',
                borderRadius: '15px',
            }}
        />
    );
}

export default QuestionIcon;